var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComplianceTime1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10,
    fill: "#FF8328",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9431 13.7972L13.7972 12.9715L11.5907 10.7555V8.03203H10.4662V11.2143L12.9431 13.7972ZM10.9988 17C10.1821 17 9.40505 16.844 8.66754 16.5319C7.93003 16.2198 7.29054 15.7932 6.74908 15.2521C6.20762 14.711 5.78074 14.0719 5.46844 13.3349C5.15615 12.5978 5 11.8211 5 11.0048C5 10.186 5.15735 9.41225 5.47206 8.68364C5.78677 7.95503 6.21465 7.32078 6.75569 6.78091C7.29672 6.24104 7.93482 5.80925 8.67001 5.48555C9.40519 5.16185 10.1808 5 10.9968 5C11.8163 5 12.59 5.16177 13.3181 5.48531C14.0462 5.80885 14.6801 6.24048 15.2198 6.78021C15.7595 7.31994 16.1912 7.95397 16.5147 8.68229C16.8382 9.41061 17 10.1846 17 11.0044C17 11.8241 16.8382 12.6005 16.5144 13.3334C16.1907 14.0663 15.759 14.7033 15.2191 15.2443C14.6792 15.7854 14.0456 16.2132 13.3183 16.5279C12.591 16.8426 11.8178 17 10.9988 17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplianceTime1);
export default __webpack_public_path__ + "static/media/ComplianceTime1.e13efa0393f30f4cf318fa9a69ecd457.svg";
export { ForwardRef as ReactComponent };